enum MessageSeverity {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

export default MessageSeverity;
